import api from '../api';

const routes = require('routes.js.erb');

const searchCallToActions = function ({ commit }, searchParams) {
  return api.get(routes.api_v5_call_to_actions_path(searchParams)).then(function (response) {
    commit('updateCallToAction', response.data.data.call_to_action);
  });
}

const getCallToAction = function ({ commit }, { id }) {
  return api.get(routes.api_v5_call_to_action_path(id)).then(function (response) {
    commit('updateCallToAction', response.data.data.call_to_action);
  });
}

export { searchCallToActions, getCallToAction };
